import { useEffect, useState } from "react";
import { collection, doc, query, addDoc, onSnapshot, deleteDoc } from "firebase/firestore";
import Modal from "../../components/modal";
import { Table } from "../../components/table";
import CreateEquipmentForm from "../../components/new-equipment-form";
import { db } from './../../firebaseConfig';
import * as Sugar from 'sugar';

const EquipmentPage = () => {
    const [filter, setFilter] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [equipos, setEquipos] = useState<any[]>([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [equipmentToDelete, setEquipmentToDelete] = useState<any>(null);

    useEffect(() => {
        let unsubscribe: (() => void) | null = null;
        fetchData().then((unsub) => {
            unsubscribe = unsub;
        });
        return () => {
            if (unsubscribe) { unsubscribe(); }
        };
    }, []);

    const fetchData = async () => {
        const q = query(collection(db, "equipos"));
        return onSnapshot(q, (querySnapshot) => {
            const equipments: any[] = [];
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                equipments.push(
                    {
                        id: doc.id,
                        ...data,
                    }
                );
            });
            setEquipos(equipments);
            setLoading(false);
        });
    };

    function onDataFiltered(evt: any) {
        const { value } = evt.target;
        setFilter(value.toLowerCase());
    }

    async function createEquipment(data: any) {
        setShowModal(false);
        const value = { ...data, is_enabled: true, created_at: new Date().getTime() };
        await addDoc(collection(db, "equipos"), value);
    }

    async function removeEquipment() {
        setDeleteModal(false);
        await deleteDoc(doc(db, "equipos", equipmentToDelete.id));
        setEquipmentToDelete(null);
    }

    const displayedData = Sugar.String.isBlank(filter) ? equipos : equipos.filter((equipo) => {
        return equipo.name.toLowerCase().includes(filter) || equipo.description.toLowerCase().includes(filter) || equipo.brand.toLowerCase().includes(filter) || equipo.model.toLowerCase().includes(filter);
    });
    const size = displayedData.length;
    return (
        <div>
            <h1>{loading ? 'Buscando equipos...' : (size === 0 ? 'Sin resultados' : `${size} ${Sugar.String.pluralize('Equipo', size)} en total`)}</h1>
            <h3>Listado de equipos administradores registrados en nuestra plataforma.</h3>
            <div className={'form-filter-container'}>
                <div className="search-container">
                    <input
                        type="text"
                        onChange={onDataFiltered}
                        placeholder="Busca por nombre, marca, modelo, descripcion..."
                    />
                </div>
                <button onClick={() => { setShowModal(true); }}>{'Nuevo Equipo'}</button>
            </div>
            <Table headers={[
                'Nombre',
                'Marca',
                'Modelo',
                'Descripción',
            ]}
                keys={[
                    'name',
                    'brand',
                    'model',
                    'description',
                ]}
                values={displayedData}
                actionBuilder={(row) => {
                    return (<div className={'table-actions-container'}>
                        <button className="icon-button icon-red tooltip-text" data-tooltip="Eliminar" onClick={() => {
                            setEquipmentToDelete(row);
                            setDeleteModal(true);
                        }}>
                            <i className="fas fa-trash-alt"></i>
                        </button>
                    </div>);
                }}
            />
            <Modal isShown={showModal}>
                <CreateEquipmentForm onCreate={createEquipment} />
                <button className={'modal-close-button'} onClick={() => { setShowModal(false); }}>Cancelar</button>
            </Modal>
            <Modal isShown={deleteModal}>
                <h2>Confirmacion de eliminación de equipo</h2>
                <h4 style={{ marginBottom: 16, fontWeight: 400 }}>Estas seguro que deseas eliminar a {equipmentToDelete?.name}?</h4>
                <button style={{ marginBottom: 0 }} onClick={removeEquipment}>Confirmar</button>
                <button className={'modal-close-button'} onClick={() => { setDeleteModal(false); }}>Cancelar</button>
            </Modal>
        </div>
    );
};

export default EquipmentPage;